<template>
  <report-settings-form :action="route('settings.location-preference')">
    <l-state-input v-model="user.statesPreferred"/>
    <l-national-input v-model="user.report.national"/>
  </report-settings-form>
</template>

<script setup>
import LNationalInput from "@/components/inputs/LNationalInput.vue"
import LStateInput from "@/components/inputs/LStateInput.vue"
import ReportSettingsForm from "@/components/forms/ReportSettingsForm.vue"
import route from "ziggy-js"

const user = defineModel({ type: Object, required: true })
</script>
